<template>
    <div>
        <v-card>
            <v-card-title class="d-flex justify-content-between w-100 mb-4">
                <h5 v-if="mode === 'update'" class="ml-2 my-4">Modification d'un moyen de paiement</h5>
                <h5 v-else-if="mode === 'create'" class="ml-2 my-4">Création d'un moyen de paiement</h5>
                <v-btn icon @click="closeModal" class="ml-auto">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-text-field
                  outlined
                  label="Intitulé du moyen de paiement"
                  v-model="paymentOption.label"
                  hide-details
                  class="mb-2"
                  :class="{'input-error': submitted && (paymentOption.label === null || paymentOption.label === '') }"
                ></v-text-field>

                <v-textarea
                  outlined
                  label="Instructions de paiement"
                  v-model="paymentOption.description"
                  hide-details
                  class="mb-2"
                  :class="{'input-error': submitted && paymentOption.code !== 'CB' &&
                  (paymentOption.description === null || paymentOption.description === '') }"
                ></v-textarea>

                <div v-if="paymentOption.code === 'VIR'">
                    <v-file-input
                      label="RIB (jpg ou png)"
                      outlined
                      dense
                      v-model="rib"
                      :rules="rules"
                      accept="image/png, image/jpeg"
                    >
                        <template
                          v-slot:append
                          v-if="paymentOption.document !== null"
                        >
                            <v-fade-transition leave-absolute>
                                <v-icon color="success">check</v-icon>
                            </v-fade-transition>
                        </template>
                    </v-file-input>
                </div>

                <div v-if="paymentOption.code === 'SEPA'">
                    <v-file-input
                      label="Mandat de prélèvement SEPA (jpg ou png)"
                      outlined
                      dense
                      v-model="sepa"
                      :rules="rules"
                      accept="image/png, image/jpeg"
                    >
                        <template
                          v-slot:append
                          v-if="paymentOption.document !== null"
                        >
                            <v-fade-transition leave-absolute>
                                <v-icon color="success">check</v-icon>
                            </v-fade-transition>
                        </template>
                    </v-file-input>
                </div>

                <div class="d-flex" v-if="paymentOption.code === 'CB'">
                    <div>
                        <v-chip v-if="cadhConfig.account.payfip_id"
                                color="secondary" class="mr-2">
                            Payfip
                        </v-chip>
                        <v-chip v-else-if="cadhConfig.account.stripe_pk"
                                color="secondary" class="mr-2">
                            Stripe
                        </v-chip>
                    </div>

                    <div>
                        <v-chip v-if="cadhConfig.account.e_payment_configured" color="green">
                            <span class="text-white">Configuré</span>
                        </v-chip>
                        <v-chip v-else-if="!cadhConfig.account.e_payment_configured" color="red">
                            <span class="text-white">Non configuré</span>
                        </v-chip>
                    </div>
                </div>

                <v-checkbox
                  label="Masquer le moyen de paiement"
                  v-model="paymentOption.enabled"
                  :true-value="false"
                  :false-value="true"
                  hide-details
                  v-if="!(!cadhConfig.account.e_payment_configured && paymentOption.code === 'CB')"
                  class="mb-2"
                ></v-checkbox>

                <div v-else-if="!cadhConfig.account.e_payment_configured && paymentOption.code === 'CB' &&
                 paymentOption.enabled" class="mt-4">
                    <v-icon class="mr-2">check_box_outline_blank</v-icon>
                    <span class="fake-disable-checkbox-label">
                                        Masquer le moyen de paiement
                                    </span>
                </div>

                <div v-else class="mt-4">
                    <v-icon class="mr-2" color="primary">check_box</v-icon>
                    <span class="fake-disable-checkbox-label">
                                        Masquer le moyen de paiement
                                    </span>
                </div>
            </v-card-text>

            <div class="text-center">
                <v-btn class="default-button mt-12 mb-6 mx-auto" @click="checkNameAndDesc" v-if="mode === 'update'">
                    Modifier le moyen de paiement
                </v-btn>
                <v-btn class="default-button mt-12 mb-6 mx-auto" @click="checkNameAndDesc" v-if="mode === 'create'">
                    Ajouter le moyen de paiement à mon adhésion
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "CreatePaymentOptionModal",
    props: ["mode", "paymentOption"],
    data() {
        return {
            submitted: false,
            rules: [
                (value) =>
                  !value || value.name.substr(value.name.length - 3) === "jpg" ||
                  value.name.substr(value.name.length - 3) === "png" ||
                  "Le fichier doit être au format .jpg ou .png",
            ],
            rib: null,
            sepa: null,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setPaymentOptionModal"]),
        closeModal() {
            this.submitted = false
            this.setPaymentOptionModal(false)
        },
        checkNameAndDesc() {
            this.submitted = true
            let checkLabel = this.paymentOption.label !== null && this.paymentOption.label !== ""
            let checkDescription = this.paymentOption.description !== null && this.paymentOption.description !== ""

            if (checkLabel && (checkDescription || this.paymentOption.code === "CB") && this.mode === "update") {
                this.submitted = false
                this.updatePaymentOption()
            } else if (checkLabel && (checkDescription || this.paymentOption.code === "CB") && this.mode === "create") {
                this.submitted = false
                this.createPaymentOption()
            }
        },
        updatePaymentOption() {
            let payload = new FormData()
            this.setPayload("paymentOptionId", this.paymentOption.id, payload)
            this.setPayload("label", this.paymentOption.label, payload)
            this.setPayload("enabled", this.paymentOption.enabled, payload)
            this.setPayload("order", this.paymentOption.order, payload)
            this.setPayload("description", this.paymentOption.description, payload)

            this.$global.loading = true

            this.setPaymentOptionModal(false)

            if (this.rib !== null) {
                let extension = this.rib.name.substr(this.rib.name.length - 3)

                if (extension === "jpg" || extension === "png") {
                    this.setPayload("rib", this.rib, payload)
                }
            } else if (this.sepa !== null) {
                let extension = this.sepa.name.substr(this.sepa.name.length - 3)

                if (extension === "jpg" || extension === "png") {
                    this.setPayload("sepa", this.sepa, payload)
                    this.setPayload("id", this.paymentOption.id, payload)
                }
            }

            this.$store.dispatch("cadhConfig/updatePaymentOption", payload)

            this.rib = null
            this.sepa = null

            this.$global.loading = false

        },
        createPaymentOption() {
            let payload = {
                "configId": this.cadhConfig.id,
                "label": this.paymentOption.label,
                "enabled": this.paymentOption.enabled,
                "order": this.paymentOption.order,
                "description": this.paymentOption.description,
                "document": this.paymentOption.document,
            }

            this.$global.loading = true

            this.setPaymentOptionModal(false)

            this.$store.dispatch("cadhConfig/createPaymentOption", payload)

            this.$global.loading = false
        },
        setPayload(key, value, payload) {
            if (value !== null) {
                payload.set(key, value)
            }
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "paymentOptionModal", "usedInCampaign"]),
    },
    created() {
    },
}
</script>